import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { breakpoints, spacing, themeLight } from '@naf/theme';
import isPropValid from '@emotion/is-prop-valid';
const propValidationConfig = {
  shouldForwardProp: prop => isPropValid(prop.toString())
};
const AccordionListItem = ({
  index,
  title,
  content,
  onOpen
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleClick = () => {
    setIsOpen(!isOpen);
    if (onOpen) {
      onOpen(title);
    }
  };
  useEffect(() => {
    if (window?.innerWidth > 680) {
      setIsOpen(true);
    }
  }, []);
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Header, {
    onClick: handleClick
  }, /*#__PURE__*/React.createElement(Bullet, {
    className: "accordionlist_bullet"
  }, index + 1), /*#__PURE__*/React.createElement(TitleWrapper, null, /*#__PURE__*/React.createElement(Title, null, title)), /*#__PURE__*/React.createElement(Chevron, {
    $isOpen: isOpen,
    height: "28px",
    width: "28px",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 10L16.59 8.59003L12 13.17L7.41 8.59003L6 10L12 16L18 10Z",
    fill: "#1A1A1A"
  }))), /*#__PURE__*/React.createElement(Body, {
    $titleLength: title.length,
    $isOpen: isOpen
  }, content));
};
export const AccordionList = ({
  accordionList
}) => /*#__PURE__*/React.createElement(ListWrapper, null, accordionList.map((item, index) => /*#__PURE__*/React.createElement(AccordionListItem, {
  key: `${item.title}-${index + 1}`,
  index: index,
  title: item.title,
  content: item.content,
  onOpen: item.onOpen
})));
const ListWrapper = styled.div.withConfig({
  displayName: "accordionList__ListWrapper",
  componentId: "sc-wrpcbz-0"
})(["display:flex;flex-wrap:wrap;flex-direction:column;justify-content:start;@media (min-width:", "){flex-direction:row;max-width:", ";gap:", ";}@media (min-width:", "){max-width:", ";}@media (min-width:", "){max-width:", ";}"], breakpoints.m, breakpoints.m, spacing.space64, breakpoints.l, breakpoints.l, breakpoints.xl, breakpoints.xl);
const Wrapper = styled.div.withConfig({
  displayName: "accordionList__Wrapper",
  componentId: "sc-wrpcbz-1"
})(["margin-bottom:20px;flex:1;@media (min-width:", "){max-width:450px;min-width:330px;}"], breakpoints.m);
const Header = styled.div.withConfig({
  displayName: "accordionList__Header",
  componentId: "sc-wrpcbz-2"
})(["display:flex;flex-direction:row;align-items:center;cursor:pointer;margin-bottom:0;:hover .accordionlist_bullet{background-color:", ";transition:0.1s ease;}"], themeLight.componentColors.cta.secondaryInverted);
const TitleWrapper = styled.div.withConfig({
  displayName: "accordionList__TitleWrapper",
  componentId: "sc-wrpcbz-3"
})(["display:flex;flex-direction:column;justify-content:center;flex-grow:1;margin-right:5px;@media (min-width:", "){flex-grow:0;margin-right:15px;}"], breakpoints.m);
const Bullet = styled.h3.withConfig({
  displayName: "accordionList__Bullet",
  componentId: "sc-wrpcbz-4"
})(["display:flex;align-items:center;justify-content:center;color:white;background-color:#267c4f;transition:background-color 0.21s ease;width:40px;height:40px;margin-right:15px;border-radius:100%;flex-shrink:0;"]);
const Title = styled.h3.withConfig({
  displayName: "accordionList__Title",
  componentId: "sc-wrpcbz-5"
})(["margin:0;flex-grow:1;@media (min-width:", "){flex-grow:0;}"], breakpoints.m);
const Chevron = styled.svg.withConfig(propValidationConfig).withConfig({
  displayName: "accordionList__Chevron",
  componentId: "sc-wrpcbz-6"
})(["transform:", ";transition:transform 0.21s ease;flex-shrink:0;"], ({
  $isOpen
}) => $isOpen ? 'rotate(180deg)' : 'rotate(0)');
const Body = styled.div.withConfig({
  displayName: "accordionList__Body",
  componentId: "sc-wrpcbz-7"
})(["max-height:", ";margin-bottom:", ";overflow:hidden;transition:max-height 0.3s ease,margin-bottom 0.3s ease;> *:not(ul,ol){margin:0 10px 0 18px;}ul,ol{margin-left:4px;}ul > li,ol > li{margin:0 auto 0 5px;}"], ({
  $isOpen
}) => $isOpen ? '500px' : '0', ({
  $isOpen
}) => $isOpen ? '20px' : '0');
//# sourceMappingURL=accordionList.js.map